import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import {
  ILegalTexts,
  WhitelabelImage,
  WhitelabelImageAltTag,
  WhitelabelImageType,
} from '@resident-nx/shared';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { footerNavItems } from '../../../../models';
import { WhitelabelImageWebComponent } from '@resident-nx/web/ui';
import { ImmomioButtonComponent } from '@immomio/ui/button';

@Component({
  selector: 'rs-web-consent-terms-and-conditions',
  templateUrl: './consent-agb.component.html',
  styleUrls: ['../shared/consent-page-base.scss', './consent-agb.component.scss'],
  imports: [ImmomioButtonComponent, TranslateModule, WhitelabelImageWebComponent, RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConsentAgbWebComponent {
  readonly WhitelabelImage = WhitelabelImage;
  readonly WhitelabelImageAltTag = WhitelabelImageAltTag;
  readonly WhitelabelImageType = WhitelabelImageType;
  readonly legalTexts = input.required<ILegalTexts>();
  readonly isLoading = input.required<boolean>();
  readonly acceptConsent = output<{ legalTextId: string; consentGiven: boolean }>();
  readonly declineConsent = output();
  readonly footerItemAgb = footerNavItems.find(item => item.link === 'agb');
}
